/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Drastic_Tech_Process_Closed_LogInputs */



/**
* | output |
* | --- |
* | "[DRASTIC close]: Process closed with code {code}" |
*
* @param {Drastic_Tech_Process_Closed_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_process_closed_log = /** @type {((inputs: Drastic_Tech_Process_Closed_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Process_Closed_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`[DRASTIC fermeture] : Processus ferme avec le code ${i?.code}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`[DRAMATIVER Abbruch]: Prozess mit Code ${i?.code} beendet`)
	if (locale === "it") return /** @type {LocalizedString} */ (`[Chiusura DRASTICA]: Processo chiuso con codice ${i?.code}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`[КРАТКОВРЕМЕННОЕ закрытие]: Процесс завершен с кодом ${i?.code}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`[Cierre DRÁSTICO]: Proceso cerrado con código ${i?.code}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`[紧急关闭]：进程已关闭，关闭代码为${i?.code}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`[DRASTIC 終了]: プロセスはコード ${i?.code} で終了しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`[अचानक बंद]: प्रक्रिया कोड ${i?.code} के साथ बंद हो गई`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`[Fechamento drástico]: Processo encerrado com o código ${i?.code}`)
	return /** @type {LocalizedString} */ (`[DRASTIC close]: Process closed with code ${i?.code}`)
});